import React, { Component } from 'react'
import {
    Title,
    Subtitle,
    Input,
    Paragraph,
    TextArea,
    CreateBtn,
    DatePicker,
    TimePicker,
    UploadBtn,
    SmallBtn
} from '../../components/Regular/index'
import { AttendessTable } from '../../components/Table/index'
import Select from '../../components/Regular/Select'
import { SubConferenceTable } from '../../components/Table/index'
import './EditConference.css'
import { connect } from 'react-redux'
// import moduleName from ''

import swal from 'sweetalert'
import { post, get, postFile } from '../../service/index'
import moment from 'moment'

class EditConference extends Component {
    constructor(props) {
        super(props)
        const { title, detail, } = props.location.state
        console.log(props)
        this.state = {
            // date picker state
            date: null,
            hh: '00',
            mm: '00',
            focused: false,

            // sub_conference
            sub_title: '',
            pdf: null,
            filename: '',

            // edit conference
            title: title,
            detail: detail,
            all_department: [],
            selected_department: 0,
            meeting_attendess: [], // left
            selected_array: [], // right

            // subconference data
            sub_conference: [],

        }

    }

    componentWillMount = () => {
        const { isLogin } = this.props.login
        if (!isLogin) {
            this.props.history.push('/login')
        }
    }

    componentDidMount = async () => {
        try {
            const { token } = this.props.login.user
            const { id: conference_id } = this.props.match.params
            const dd = await get('/department', token)
            const allUser = await post('/get_user_conference_read', { conference_id }, token)
            const data = await post('/get_sub_conference', { conference_id }, token)
            this.setState({
                all_department: [{ value: -1, label: '---เลือกทั้งหมด---' },
                ...dd.result.map(el => ({ value: el.id, label: el.department_name }))],
                meeting_attendess: allUser.result.map(el => ({ ...el, status: 0 })), // 0 = defaul , 1 = delete , 2 = add
                sub_conference: data.result.map(el => ({
                    ...el,
                    status: 0, // status 0 = from service , 1 = delete, 2 = add
                    pdf: {
                        name: el.document_name
                    }
                })),
            })
        } catch (error) {
            console.log(error)
        }
    }


    render() {
        const { date, focused, hh, mm, title, detail, selected_department, sub_conference, filename } = this.state
        const { token } = this.props.login.user
        // console.log('token',token);
        return (
            <div className='edit-conference' >
                <div className='edit-conference-context' >
                    <div className='edit-header'>
                        <p> แก้ไขการประชุม </p>
                    </div>
                    <div className='edit-body'>
                        <div className='container' >
                            <div className='create-container2' >

                                {/* ====================== Create Left ============================ */}
                                <div className='create-left' >
                                    <Subtitle text='ข้อมูลการประชุม' marginTop={39} />
                                    <Paragraph text='ชื่อการประชุม' />
                                    <Input marginTop={16} value={title} name='title' onChange={this._handleOnChange} />
                                    <Paragraph text='รายละเอียดการประชุม' marginTop={10} />
                                    <TextArea lines={18} marginTop={16} name='detail' value={detail} onChange={this._handleOnChange} />

                                </div>

                                {/* ===================== Create Right =========================== */}
                                <div className='create-right' >
                                    <Subtitle text='เพิ่มการประชุม' marginTop={38} />
                                    {/* date picker */}
                                    <div style={{ display: 'flex', flexDirection: 'row' }} >
                                        <div style={{ flex: 2 }} >
                                            <Paragraph text='ชื่อวาระประชุม' />
                                            <Input marginTop={16} value={this.state.sub_title} name='sub_title' onChange={this._handleOnChange} />
                                        </div>
                                        <div style={{ flex: 1, marginLeft: 30 }} >
                                            <Paragraph text='วันที่ประชุม' marginBottom={16} />
                                            <DatePicker _onChange={this._onChange} date={date} focused={focused} _onFocusedChange={this._onFocusedChange} />
                                        </div>
                                    </div>

                                    {/* upload file */}
                                    <div style={{ display: 'flex', flexDirection: 'row' }} >
                                        <div style={{ flex: 1 }} >
                                            <Paragraph text='อัปโหลดเอกสาร' marginTop={10} />
                                            <UploadBtn marginTop={10} name='pdf' onChange={this._handleFileUpload} filename={filename} />
                                        </div>

                                        <div style={{ flex: 1 }} >
                                            <Paragraph text='เวลาที่ประชุม' marginTop={10} marginLeft={30} />
                                            <TimePicker marginTop={10} marginLeft={28} _handleChange={this._onChange} hh={hh} mm={mm} />
                                            <SmallBtn title='+ เพิ่มหัวข้อ' marginTop={16} marginLeft={30} onClick={this._handleAddSub} />
                                        </div>

                                    </div>

                                    <Subtitle text='วาระการประชุม' />
                                    <SubConferenceTable subCF={sub_conference} onDelete={this._onDeleteSub} token={token} />

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='edit-footer'>
                        <div className='container' >
                            <div className='attendess-container' >
                                {/*  ============= Attendess Left =============  */}
                                <div className='attendess-left' >
                                    <Subtitle text='ผู้เข้าร่วมประชุม' marginTop={20} />
                                    <span style={{ width: '100%', marginTop: 20, textAlign: 'right' }} onClick={this.deleteAll} ><a>ลบทั้งหมด</a></span>
                                    <AttendessTable selectedPerson={this.state.meeting_attendess} marginTop={20} tableMode={2} handleRemoveUser={this._onDelete} />
                                </div>

                                {/* ============= Attendess Right ============== */}
                                <div className='attendess-right' >
                                    <Subtitle text='เลือกผู้เข้าร่วมประชุม' marginTop={20} />
                                    <Select title='เลือกหน่วยงาน' value={selected_department} options={this.state.all_department} onChange={this._onSelect} />
                                    <span style={{ width: '100%', marginTop: 20, textAlign: 'right' }} onClick={this.selectAll} ><a>เลือกทั้งหมด</a></span>
                                    <AttendessTable selectedPerson={this.state.selected_array} marginTop={20} tableMode={1} handleAddUser={this._onAdd} handleRemoveUser={this._onDelete} />
                                </div>
                            </div>
                            <div className='attendess-footer' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }} >
                                <CreateBtn text='บันทึก' onClick={this.handleSave} />
                                <CreateBtn text='ลบการประชุม' mode={1} marginLeft={20} onClick={this.deleteConference} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

    _onChange = key =>
        value => this.setState({ [key]: value })

    _onFocusedChange = ({ focused }) => this.setState({ focused })

    _onSelect = async (value) => {
        const { token } = this.props.login.user
        const { meeting_attendess } = this.state
        this.setState({ selected_department: value })
        if (value) {
            try {
                const getDepartment = await post('/person_department', { department_id: value.value }, token)
                const { result } = getDepartment
                // check previous arr

                const selecetdResult = result.map(el => {
                    const selected = meeting_attendess.some(ev => ev.user_id === el.id && ev.status !== 1)
                    return { ...el, selected }
                })
                this.setState({ selected_array: selecetdResult })
            } catch (err) {
                swal('การรับหน่วยงานผิดพลาด กรุณาลองใหม่ในภายหลัง', '', 'error')
            }
        } else {
            this.setState({ selected_array: [] })
        }

    }

    _handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value })


    //  sub conferenec table
    _handleFileUpload = e => {
        this.setState({ [e.target.name]: e.target.files[0], filename: e.target.files[0].name })

    }

    _onDeleteSub = (index) => () => {

        this.setState(prevState => ({
            sub_conference: prevState.sub_conference[index].status === 0 ? [
                ...prevState.sub_conference.slice(0, index), {
                    ...prevState.sub_conference[index],
                    status: 1
                }, ...prevState.sub_conference.slice(index + 1)] :
                [
                    ...prevState.sub_conference.slice(0, index),
                    ...prevState.sub_conference.slice(index + 1)]
            ,
        }))
    }

    _handleAddSub = () => {
        const { sub_title, date, hh, mm, pdf } = this.state
        const dateL = moment(this.state.date).format('YYYY-MM-DD').split('-')
        const meeting_time = `${Number(dateL[0]) + 543}-${dateL[1]}-${dateL[2]} ${hh}:${mm}:00`

        if (sub_title && date && pdf) {
            this.addSub(sub_title, meeting_time, pdf)
            this.setState({ sub_title: '', pdf: '', filename: '' })
        } else {
            swal('กรุณาตรวจสอบข้อมูลก่อนเพิ่มหัวข้อ', '', 'warning')
        }

    }

    addSub = async (sub_title, meeting_time, pdf) => {
        const { id: conference_id } = this.props.match.params
        const { token } = this.props.login.user
        const { sub_conference } = this.state
        try {
            const data = new FormData()
            data.append('title', sub_title)
            data.append('meeting_time', meeting_time)
            data.append('conference_id', conference_id)
            data.append('pdf', pdf)
            data.append('position', 1 + sub_conference.length)

            const addNewSub = await postFile('/create_sub_conference', data, token)

            this.setState(prevState => ({
                sub_conference: [...prevState.sub_conference, {
                    title: sub_title,
                    meeting_time,
                    pdf,
                    status: 2,
                    sub_id: addNewSub.sub_id,
                    position: 1 + sub_conference.length,
                }]
            }))
        } catch (error) {

        }

    }

    // user table
    // add user
    _onAdd = (userObj, index) =>
        () => {

            this.setState(prevState => ({
                meeting_attendess: [...prevState.meeting_attendess, { ...userObj, user_id: userObj.id, status: 2 }],
                selected_array: [...prevState.selected_array.slice(0, index),
                { ...prevState.selected_array[index], selected: true },
                ...prevState.selected_array.slice(index + 1),
                ]
            }))

        }
    // remove user
    _onDelete = id => () => {
        const { user_id } = this.props.login.user
        if (user_id === id) {
            swal('ไม่สามารถลบคนสร้างการประชุมได้', '', 'warning')
        } else {
            this.setState(prevState => {
                const meeting_id = prevState.meeting_attendess.findIndex(el => el.user_id == id)
                const seleted_id = prevState.selected_array.findIndex(el => el.id == id)

                return ({
                    meeting_attendess: meeting_id >= 0 ? prevState.meeting_attendess[meeting_id].status === 0 ? [...prevState.meeting_attendess.slice(0, meeting_id), { ...prevState.meeting_attendess[meeting_id], status: 1 }, ...prevState.meeting_attendess.slice(meeting_id + 1)] : [...prevState.meeting_attendess.slice(0, meeting_id), ...prevState.meeting_attendess.slice(meeting_id + 1)] : prevState.meeting_attendess,
                    selected_array: seleted_id >= 0 ? [...prevState.selected_array.slice(0, seleted_id), { ...prevState.selected_array[seleted_id], selected: false }, ...prevState.selected_array.slice(seleted_id + 1)] : prevState.selected_array
                })

            })
        }

    }

    // select all
    selectAll = () => {
        this.setState(prevState => ({
            meeting_attendess: [...prevState.meeting_attendess, ...prevState.selected_array.reduce((acc, cv) => {

                if (!prevState.meeting_attendess.some(el => el.user_id === cv.id)) {
                    return [...acc, { ...cv, status: 2, user_id: cv.id }]
                } else {
                    return acc
                }
            }, [])],
            selected_array: prevState.selected_array.map(el => ({ ...el, selected: true }))
        }))
    }

    // delete all
    deleteAll = () => {
        const { user_id } = this.props.login.user
        this.setState(prevState => ({
            meeting_attendess: prevState.meeting_attendess.reduce((acc, cv) => {
                if (cv.user_id == user_id) {
                    return [...acc, cv]
                } else if (cv.status == 0) {
                    return [...acc, { ...cv, status: 1 }]
                } else {
                    return acc
                }
            }, []),
            selected_array: prevState.selected_array.map(el => {
                if (el.id == user_id || el.user_id == user_id) {
                    return el
                }
                return ({ ...el, selected: false })
            })
        }))
    }

    // delete conference
    deleteConference = () => {
        const { id: conference_id } = this.props.match.params
        const { token } = this.props.login.user

        swal('ต้องการลบการประชุมใช่หรือไม่', '', 'warning', { buttons: [true, 'ตกลง'] }).then(async suc => {
            if (suc) {
                try {
                    const deleteConf = await post('/delete_conference', { conference_id }, token)
                    swal('ลบการประชุมสำเร็จ', '', 'success', { buttons: [true, 'ตกลง'] }).then(success => {
                        this.props.history.push('/')
                    })
                } catch (err) {
                    console.log(err)
                    swal(err, '', 'error')

                }
            }
        })


    }

    // save conference
    handleSave = async () => {

        const { id: conference_id } = this.props.match.params
        const { token } = this.props.login.user
        const { title, detail, sub_conference, meeting_attendess } = this.state

        try {
            const editConf = await post('/edit_conference', { title, detail, conference_id }, token)
            // edit sub
            sub_conference.forEach(async element => {
                try {
                    if (element.status === 1) {
                        const deleteSub = await post('/delete_sub_conference', { conference_id, sub_conference_id: element.id }, token)
                    }
                    // else if (element.status === 2) {
                    //     const { title, meeting_time, pdf } = element
                    //     const data = new FormData()
                    //     data.append('title', title)
                    //     data.append('meeting_time', meeting_time)
                    //     data.append('conference_id', conference_id)
                    //     data.append('pdf', pdf)

                    //     const addNewSub = await postFile('/create_sub_conference', data, token)

                    // }

                } catch (err) {
                    console.log(err)
                    swal('เพิ่มวาระการประชุมผิดพลาด')
                }
            });

            // edit attendess
            let newUser = []
            meeting_attendess.forEach(async (element, i) => {
                try {
                    // console.log(element)
                    if (element.status !== 1) {
                        newUser.push(element.user_id)
                    }

                    if (i === meeting_attendess.length - 1) {
                        const addUser = await post('/edit_user_conference', { conference_id, user: newUser }, token)

                    }
                } catch (err) {
                    console.log(err)
                    swal('เพิ่ม user ผิลพลาด', '', 'error')
                }
            });

            swal('แก้ไขการประชุมสำเร็จ', '', 'success')

        } catch (err) {
            swal('แก้ไขข้อมูลผิลพลาด', '', 'error')
            console.log(err)
        }
    }

}

const mapStateToProps = (state) => ({
    login: state.login
})

export default connect(mapStateToProps)(EditConference)




// WEBPACK FOOTER //
// ./src/pages/EditConference/EditConference.js